import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';

import { CedulaC } from '../_classes/cedula-c';
import { Util } from '../_classes/util';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';
import { RestService } from '../_servicos/rest.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { ServidorService } from './../_servicos/servidor.service';

@Component({
  selector: 'app-comprovante-rendimento',
  templateUrl: './comprovante-rendimento.component.html',
  styleUrls: ['./comprovante-rendimento.component.scss'],
})
export class ComprovanteRendimentoComponent implements OnInit {
  private readonly recurso: string = 'comprovante-rendimento';
  arquivoUrl: any;
  hidePdfViewer = true;

  carregando = false;
  erros$ = new Subject<boolean>();
  dataSource$: Observable<CedulaC[]>;
  dataSource: MatTableDataSource<CedulaC>;
  displayedColumns: string[] = ['nrAnoCalendario', 'snRetificadora', 'ver'];

  length = 100;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;

  previa: boolean = false;

  modalRef: BsModalRef;
  config = {
    keyboard: true,
    class: 'modal-lg',
  };

  itensAjuda = [
    {
      titulo: 'Ano Calendário',
      texto:
        'Indicativo do ano de calendário a que se refere o comprovante de redimentos para IRPF',
    },
    { titulo: 'Informações', texto: 'Campo destinado às informações gerais' },
    {
      titulo: 'Ver',
      texto:
        'Local onde existem dois ícones para você poder baixar ou visualizar o documento',
    },
  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private sanitizer: DomSanitizer,
    private modalService: BsModalService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {
    this.dataSource = new MatTableDataSource([]);
    this.atualizarPaginador();
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput
      .split(',')
      .map((str) => +str);
  }

  buscar(
    pTemplate: TemplateRef<any>,
    pI: number,
    pTipoCedulaC: string,
    pBaixar: boolean,
    pTipo: string
  ) {
    //console.log('buscar', pTemplate, pI, pTipoCedulaC, pBaixar, pTipo);
    this.carregando = true;
    //console.log('Carregando aterado8', this.carregando);
    setTimeout(function () {
      this.carregando = false;
      //console.log('Carregando aterado9', this.carregando);
    }, 10000);

    if (this.env.servidor) {
      this.service
        .getCedulaC(this.env.servidor.idServidor, pI, pTipoCedulaC)
        .subscribe((a: CedulaC) => {
          //console.log('retorno', a);
          if (a.bbCedulaC) {
            this.previa = false;
          } else {
            if (a.bbPreviaCedulaC) {
              this.previa = true;
            } else {
              this.previa = false;
            }
          }

          this.executarAoMostrarOuDownloadBlob(
            pTipo.toUpperCase() === 'PDF'
              ? new CedulaC(a).documentoValido()
              : new CedulaC(a).bbXml,
            pTemplate,
            pBaixar,
            new CedulaC(a).nomeArquivo('', pTipo.toUpperCase()),
            pTipo
          );
        });
    }
  }

  mostrar(pTemplate: TemplateRef<any>, pI: number, pTipoCedulaC: string) {
    //console.log('mostrar', pI, pTipoCedulaC);
    this.buscar(pTemplate, pI, pTipoCedulaC, false, 'PDF');
  }

  nomeDoArquivo(x: CedulaC, pExtensao: string) {
    //console.log('nomeDoArquivo', pExtensao);
    return x.nomeArquivo('', pExtensao.toUpperCase());
  }

  download(pI: number, pTipo: string, pTipoCedulaC: string) {
    //console.log('download', pI, pTipo, pTipoCedulaC);
    this.buscar(null, pI, pTipoCedulaC, true, pTipo.toUpperCase());
  }

  ngOnInit() {
    this.atualizar();
  }

  /*
  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }*/

  executarAoCarregarDatasource(x: CedulaC[]) {
    this.dataSource = new MatTableDataSource<CedulaC>(x);
    this.atualizarPaginador();
    this.carregando = false;
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  atualizarPaginador() {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    ////console.log(this.dataSource.filteredData.length + '-' + this.length);
  }

  executarAoMostrarOuDownloadBlob(
    x: Blob,
    template: TemplateRef<any>,
    pBaixar: boolean,
    nomeDoArquivo: string,
    pTipo: string
  ) {
    ////console.log('Blob X', x);
    //console.log('executarAoMostrarOuDownloadBlob',      x,      template,      pBaixar,      nomeDoArquivo,      pTipo    );

    if (x) {
      let blob;

      if (pTipo.toUpperCase() === 'PDF') {
        //console.log('criei BLOB PDF', pTipo);
        blob = new Blob([Util.Base64ToBlob(x)], {
          type: 'application/pdf',
        });
      } else {
        //console.log('criei BLOB XML', pTipo);
        blob = new Blob([Util.Base64ToBlob(x)], {
          type: 'application/xml',
        });
      }

      this.arquivoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        window.URL.createObjectURL(blob)
      );
      //console.log('Blob depois de sanitizado', this.arquivoUrl);
      if (!pBaixar) {
        this.modalRef = this.modalService.show(template, this.config);
        this.carregando = false;
        //console.log('Carregando aterado1', this.carregando);
      } else {
        let newVariable: any = window.navigator;
        if (newVariable && newVariable.msSaveOrOpenBlob) {
          newVariable.msSaveOrOpenBlob(blob); //console.log('Carregando aterado2', this.carregando);
          this.carregando = false;
          return;
        }
        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(blob);

        let link = document.createElement('a');
        link.href = data;
        link.download = nomeDoArquivo;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        this.carregando = false;
        //console.log('Carregando aterado3', this.carregando);

        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          if (this.carregando) {
            this.carregando = false;
            //console.log('Carregando aterado4', this.carregando);
          }
        }, 10000);
      }
    } else {
      this.carregando = false;
      //console.log('Carregando aterado5', this.carregando);
      this.handleError('Documento está com problemas para ser exibido.');
    }
  }

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  private t: any;

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }
  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    this.dataSource$ = this.service
      .listarCedulaC(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }

  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
